import React, { useEffect, useState } from 'react'
import Table from 'react-bootstrap/Table'
import api from './../components/api'
import { Link } from 'react-router-dom'
//import { useTabelaGestao } from '../context/GestaoPendenciasContext'
import moment from 'moment'

import { useEnunciadoContext } from '../context/enunciadoContext'
import { useVerificaDesafioContext } from '../context/verificaDesafioContext'
import { useSecaoEnunciadoContext } from '../context/secaoEnunciadoContext'

import StatusValidacaoSecao from '../components/StatusValidacaoSecao'


const AcoesLideranca = (props) => {

    var ano = props.ano
    var adesao_institucional_id = props.adesao_institucional_id
    var formulario_id = props.formulario_id


    //var { atualizacaoGestao, setAtualizacaoGestao } = useTabelaGestao()

    var { enunciado, setEnunciado } = useEnunciadoContext()
    var { setSecaoEnunciado } = useSecaoEnunciadoContext()
    var { verificaDesafio } = useVerificaDesafioContext()



    var [hospClima_id, setHospClima_id] = useState()

    var [lideranca_funcionarios, setLideranca_funcionarios] = useState()
    var [lideranca_medicos, setLideranca_medicos] = useState()
    var [lideranca_pacientes, setLideranca_pacientes] = useState()
    var [lideranca_comunidade, setLideranca_comunidade] = useState()
    var [lideranca_atividades, setLideranca_atividades] = useState()
    var [trabalhouMS_Atividades, setTrabalhouMS_Atividades] = useState('')
    var [economica_energiaLimpa, setEconomica_energiaLimpa] = useState()
    var [economica_carvao, setEconomica_carvao] = useState()
    var [economica_fosseis, setEconomica_fosseis] = useState()
    var [economica_atividades, setEconomica_atividades] = useState('')
    var [politica_reducaoEmissao, setPolitica_reducaoEmissao] = useState()
    var [politica_adaptacaoSetor, setPolitica_adaptacaoSetor] = useState()
    var [politica_transicaoCombustiveis, setPolitica_transicaoCombustiveis] = useState()
    var [politica_acesso, setPolitica_acesso] = useState()
    var [iniciativasLideranca, setIniciativasLideranca] = useState()

    var [lideranca_visitantes, setLideranca_visitantes] = useState();
    var [lideranca_midia, setLideranca_midia] = useState();
    var [lideranca_outro, setLideranca_outro] = useState();
    var [lideranca_outro_descricao, setLideranca_outro_descricao] = useState('');
    var [lideranca_capacitacao, setLideranca_capacitacao] = useState();
    var [lideranca_capacitacao_descricao, setLideranca_capacitacao_descricao] = useState('');
    var [lideranca_educativa_local, setLideranca_educativa_local] = useState();
    var [lideranca_educativa_estadual, setLideranca_educativa_estadual] = useState();
    var [lideranca_educativa_nacional, setLideranca_educativa_nacional] = useState();
    var [lideranca_educativa_descricao, setLideranca_educativa_descricao] = useState('');
    var [politica_clima_gee, setPolitica_clima_gee] = useState();
    var [politica_clima_gee_nivel, setPolitica_clima_gee_nivel] = useState('');
    var [politica_clima_adaptacao, setPolitica_clima_adaptacao] = useState();
    var [politica_clima_adaptacao_nivel, setPolitica_clima_adaptacao_nivel] = useState('');
    var [politica_clima_transicao, setPolitica_clima_transicao] = useState();
    var [politica_clima_transicao_nivel, setPolitica_clima_transicao_nivel] = useState('');
    var [politica_clima_mitigacao, setPolitica_clima_mitigacao] = useState();
    var [politica_clima_mitigacao_nivel, setPolitica_clima_mitigacao_nivel] = useState('');
    var [politica_clima_descricao, setPolitica_clima_descricao] = useState('');
    var [governanca_funcionarios, setGovernanca_funcionarios] = useState();
    var [governanca_funcionarios_descricao, setGovernanca_funcionarios_descricao] = useState('');
    var [governanca_verdes, setGovernanca_verdes] = useState();
    var [governanca_verdes_descricao, setGovernanca_verdes_descricao] = useState('');
    var [governanca_mitigacao, setGovernanca_mitigacao] = useState();
    var [governanca_mitigacao_descricao, setGovernanca_mitigacao_descricao] = useState('');
    var [governanca_incentivos, setGovernanca_incentivos] = useState();
    var [governanca_incentivos_descricao, setGovernanca_incentivos_descricao] = useState('');
    var [governanca_beneficios, setGovernanca_beneficios] = useState();
    var [governanca_beneficios_descricao, setGovernanca_beneficios_descricao] = useState('');
    var [economica_plano_carbono, setEconomica_plano_carbono] = useState();
    var [economica_plano_carbono_descricao, setEconomica_plano_carbono_descricao] = useState('');
    var [economica_energiaLimpa_descricao, setEconomica_energiaLimpa_descricao] = useState('');
    var [economica_eficientes, setEconomica_eficientes] = useState('');
    var [economica_eficientes_descricao, setEconomica_eficientes_descricao] = useState('');
    var [economica_acordo, setEconomica_acordo] = useState('');
    var [economica_acordo_descricao, setEconomica_acordo_descricao] = useState('');
    var [economica_carvao_descricao, setEconomica_carvao_descricao] = useState('');
    var [economica_fosseis_descricao, setEconomica_fosseis_descricao] = useState('');
    var [economica_compra_carbono, setEconomica_compra_carbono] = useState('');
    var [economica_compra_carbono_descricao, setEconomica_compra_carbono_descricao] = useState('');



    const [questao3, setQuestao3] = useState()
    const [questao4, setQuestao4] = useState()
    const [questao5, setQuestao5] = useState()
    const [questao6, setQuestao6] = useState()

    const [questao7, setQuestao7] = useState()
    const [questao8, setQuestao8] = useState()
    const [questao9, setQuestao9] = useState()
    const [questao10, setQuestao10] = useState()
    const [questao11, setQuestao11] = useState()
    const [questao12, setQuestao12] = useState()
    const [questao13, setQuestao13] = useState()
    const [questao14, setQuestao14] = useState()
    const [questao15, setQuestao15] = useState()
    const [questao16, setQuestao16] = useState()
    const [questao17, setQuestao17] = useState()
    const [questao18, setQuestao18] = useState()
    const [questao19, setQuestao19] = useState()


    const [totalPendencias, setTotalPendencias] = useState(0)


    async function carregaAcoesLideranca() {


        await api.get(`desafioClimaAcoes/${adesao_institucional_id}/${ano}`).then((result) => {

            var data = result.data[0]

            setHospClima_id(data.hospClima_id)
            setEconomica_atividades(data.economica_atividades)
            setEconomica_energiaLimpa(data.economica_energiaLimpa)
            setEconomica_fosseis(data.economica_fosseis)
            setEconomica_carvao(data.economica_carvao)
            setIniciativasLideranca(data.iniciativasLideranca)
            setLideranca_atividades(data.lideranca_atividades)
            setLideranca_comunidade(data.lideranca_comunidade)
            setLideranca_funcionarios(data.lideranca_funcionarios)
            setLideranca_medicos(data.lideranca_medicos)
            setLideranca_pacientes(data.lideranca_pacientes)
            setPolitica_acesso(data.politica_acesso)
            setPolitica_adaptacaoSetor(data.politica_adaptacaoSetor)
            setPolitica_reducaoEmissao(data.politica_reducaoEmissao)
            setPolitica_transicaoCombustiveis(data.politica_transicaoCombustiveis)

            setTrabalhouMS_Atividades(data.trabalhouMS_Atividades)

            setLideranca_visitantes(data.lideranca_visitantes)
            setLideranca_midia(data.lideranca_midia)
            setLideranca_outro(data.lideranca_outro)
            setLideranca_outro_descricao(data.lideranca_outro_descricao)
            setLideranca_capacitacao(data.lideranca_capacitacao)
            setLideranca_capacitacao_descricao(data.lideranca_capacitacao_descricao)
            setLideranca_educativa_local(data.lideranca_educativa_local)
            setLideranca_educativa_estadual(data.lideranca_educativa_estadual)
            setLideranca_educativa_nacional(data.lideranca_educativa_nacional)
            setLideranca_educativa_descricao(data.lideranca_educativa_descricao)
            setPolitica_clima_gee(data.politica_clima_gee)
            setPolitica_clima_gee_nivel(data.politica_clima_gee_nivel)
            setPolitica_clima_adaptacao(data.politica_clima_adaptacao)
            setPolitica_clima_adaptacao_nivel(data.politica_clima_adaptacao_nivel)
            setPolitica_clima_transicao(data.politica_clima_transicao)
            setPolitica_clima_transicao_nivel(data.politica_clima_transicao_nivel)
            setPolitica_clima_mitigacao(data.politica_clima_mitigacao)
            setPolitica_clima_mitigacao_nivel(data.politica_clima_mitigacao_nivel)
            setPolitica_clima_descricao(data.politica_clima_descricao)
            setGovernanca_funcionarios(data.governanca_funcionarios)
            setGovernanca_funcionarios_descricao(data.governanca_funcionarios_descricao)
            setGovernanca_verdes(data.governanca_verdes)
            setGovernanca_verdes_descricao(data.governanca_verdes_descricao)
            setGovernanca_mitigacao(data.governanca_mitigacao)
            setGovernanca_mitigacao_descricao(data.governanca_mitigacao_descricao)
            setGovernanca_incentivos(data.governanca_incentivos)
            setGovernanca_incentivos_descricao(data.governanca_incentivos_descricao)
            setGovernanca_beneficios(data.governanca_beneficios)
            setGovernanca_beneficios_descricao(data.governanca_beneficios_descricao)
            setEconomica_plano_carbono(data.economica_plano_carbono)
            setEconomica_plano_carbono_descricao(data.economica_plano_carbono_descricao)
            setEconomica_energiaLimpa_descricao(data.economica_energiaLimpa_descricao)
            setEconomica_eficientes(data.economica_eficientes)
            setEconomica_eficientes_descricao(data.economica_eficientes_descricao)
            setEconomica_acordo(data.economica_acordo)
            setEconomica_acordo_descricao(data.economica_acordo_descricao)
            setEconomica_carvao_descricao(data.economica_carvao_descricao)
            setEconomica_fosseis_descricao(data.economica_fosseis_descricao)
            setEconomica_compra_carbono(data.economica_compra_carbono)
            setEconomica_compra_carbono_descricao(data.economica_compra_carbono_descricao)


        }).catch((err) => {

            console.log(err.response)

        })


    }


    useEffect(() => {


        setHospClima_id()
        setEconomica_atividades('')
        setEconomica_energiaLimpa()
        setEconomica_fosseis()
        setEconomica_carvao()
        setIniciativasLideranca('')
        setLideranca_atividades('')
        setLideranca_comunidade()
        setLideranca_funcionarios()
        setLideranca_medicos()
        setLideranca_pacientes()
        setPolitica_acesso()
        setPolitica_adaptacaoSetor()
        setPolitica_reducaoEmissao()
        setPolitica_transicaoCombustiveis()
        setTrabalhouMS_Atividades('')

        setLideranca_visitantes();
        setLideranca_midia();
        setLideranca_outro();
        setLideranca_outro_descricao('');
        setLideranca_capacitacao();
        setLideranca_capacitacao_descricao('');
        setLideranca_educativa_local();
        setLideranca_educativa_estadual();
        setLideranca_educativa_nacional();
        setLideranca_educativa_descricao('');
        setPolitica_clima_gee();
        setPolitica_clima_gee_nivel('');
        setPolitica_clima_adaptacao();
        setPolitica_clima_adaptacao_nivel('');
        setPolitica_clima_transicao();
        setPolitica_clima_transicao_nivel('');
        setPolitica_clima_mitigacao();
        setPolitica_clima_mitigacao_nivel('');
        setPolitica_clima_descricao('');
        setGovernanca_funcionarios();
        setGovernanca_funcionarios_descricao('');
        setGovernanca_verdes();
        setGovernanca_verdes_descricao('');
        setGovernanca_mitigacao();
        setGovernanca_mitigacao_descricao('');
        setGovernanca_incentivos();
        setGovernanca_incentivos_descricao('');
        setGovernanca_beneficios();
        setGovernanca_beneficios_descricao('');
        setEconomica_plano_carbono();
        setEconomica_plano_carbono_descricao('');
        setEconomica_energiaLimpa_descricao('');
        setEconomica_eficientes('');
        setEconomica_eficientes_descricao('');
        setEconomica_acordo('');
        setEconomica_acordo_descricao('');
        setEconomica_carvao_descricao('');
        setEconomica_fosseis_descricao('');
        setEconomica_compra_carbono('');
        setEconomica_compra_carbono_descricao('');


        setQuestao3()
        setQuestao4()
        setQuestao5()
        setQuestao6()

        setQuestao7()
        setQuestao8()
        setQuestao9()
        setQuestao10()
        setQuestao11()
        setQuestao12()
        setQuestao13()
        setQuestao14()
        setQuestao15()
        setQuestao16()
        setQuestao17()
        setQuestao18()
        setQuestao19()



        if (ano) {

            carregaAcoesLideranca()

        }



    }, [ano, adesao_institucional_id, formulario_id])



    useEffect(() => {

        verificaValidacoes()

    }, [hospClima_id, verificaDesafio, formulario_id])


    const verificaValidacoes = () => {

        //console.log('verificado')


        setQuestao3()
        setQuestao4()
        setQuestao5()
        setQuestao6()

        setQuestao7()
        setQuestao8()
        setQuestao9()
        setQuestao10()
        setQuestao11()
        setQuestao12()
        setQuestao13()
        setQuestao14()
        setQuestao15()
        setQuestao16()
        setQuestao17()
        setQuestao18()
        setQuestao19()


        if (hospClima_id) {

            var dataPost = {

                formulario_id: hospClima_id,
                desafio: 'Clima',

            }

            api.post('desafioValidaVarios', dataPost).then((result) => {


                var data = result.data
                var totalErros = 0
                
                //console.log(data)

                for (var k = 0; k < data.length; k++) {

                    if (data[k].status == 'Erro') {

                        


                        switch (data[k].enunciado) {

                            /*
                            case 'Sua instituição conduziu treinamentos sobre impactos da mudança do clima na saúde e soluções saudáveis para o problema*?':

                                setQuestao3('red')

                                break

                            case 'Sua instituição atuou em defesa de políticas para o enfrentamento da mudança do clima nas seguintes questões*?':

                                setQuestao4('red')

                                break

                            case 'Sua instituição*:':

                                setQuestao5('red')

                                break

                            case 'Utilize o campo abaixo para fornecer informações adicionais sobre as iniciativas de liderança climática como, por exemplo:':

                                setQuestao6('red')

                                break

                            */


                            case 'Sua instituição conduziu treinamentos sobre impactos da mudança do clima na saúde e soluções saudáveis para o problema*?':
                                
                                setQuestao3('red')
                                var totalErros = totalErros + 1

                                break

                            case 'A sua instituição realizou capacitações em comunicação de riscos e gestão de crises (focada nos impactos das alterações climáticas na saúde) aos seus colaboradores, comunidade interna e à liderança?':

                                setQuestao4('red')
                                var totalErros = totalErros + 1

                                break

                            case 'A sua instituição participou em atividades educativas e de sensibilização entre tomadores de decisões para debater os impactos climáticos na saúde e trouxe soluções para o problema?':

                                setQuestao5('red')
                                var totalErros = totalErros + 1

                            break


                            case 'Sua instituição atuou em defesa de políticas para o enfrentamento da mudança do clima nas seguintes questões*?':

                                setQuestao6('red')
                                var totalErros = totalErros + 1

                            break

                            case 'A sua instituição tem funcionários, equipe ou comitê dedicado(s) ao trabalho sobre clima e saúde*?':

                                setQuestao7('red')
                                var totalErros = totalErros + 1

                            break

                            case 'A sua instituição tem políticas para edifícios verdes e reformas que seguem normas ou melhores práticas nacionais ou internacionais. *?':

                                setQuestao8('red')
                                var totalErros = totalErros + 1

                            break


                            case 'A sua instituição tem políticas que a comprometem a tomar medidas em matéria de mitigação e resiliência *?':

                                setQuestao9('red')
                                var totalErros = totalErros + 1

                            break


                            case 'A sua instituição oferece incentivos ou oportunidades para apoiar os funcionários na redução da sua pegada de carbono?':

                                setQuestao10('red')
                                var totalErros = totalErros + 1

                            break

                            case 'A sua instituição oferece benefícios comunitários que reduzem as emissões de carbono ou aumentam a resiliência da comunidade':

                                setQuestao11('red')
                                var totalErros = totalErros + 1

                            break

                            case 'Sua instituição avalia o plano estratégico de negócio visando encontrar benefícios económicos viáveis para a implementação de políticas, projetos e iniciativas para reduzir a sua pegada de carbono *?':

                                setQuestao12('red')
                                var totalErros = totalErros + 1

                            break

                            case 'Investiu em projetos de energia limpa, saudável ou renovável *?':

                                setQuestao13('red')
                                var totalErros = totalErros + 1

                            break

                            case 'Investiu em projetos ou empresas energeticamente eficientes *?':

                                setQuestao14('red')
                                var totalErros = totalErros + 1

                            break

                            case 'Criou um programa/acordo interno que reinveste a parte dos recursos financeiros economizados em futuros projetos de energia e sustentabilidade *?':

                                setQuestao15('red')
                                var totalErros = totalErros + 1
                                
                            break

                            case 'Sua instituição congelou investimentos em outros combustíveis fósseis?':

                                setQuestao16('red')
                                var totalErros = totalErros + 1

                            break

                            case 'Sua instituição congelou investimentos em carvão?':

                                setQuestao17('red')
                                var totalErros = totalErros + 1
                                
                            break

                            
                            case 'Adotou critérios para compra de produtos com base na sua sustentabilidade e pegada de carbono *?':

                                setQuestao18('red')
                                var totalErros = totalErros + 1
                                

                            break

                                

                        }

                    }



                }

                setTotalPendencias(totalErros)

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }



    return (

        <div>

            <div className="row">

                <div className="col-md-12">

                    <b>LIDERANÇA EM COMUNICAÇÃO</b>

                    <br /><br />

                    <p><b>Sobre este formulário:</b></p>
                    <p>1. Preencha este formulário de resiliência climática com informações da sua instituição.</p>
                    <p>2. Para concorrer ao Prêmio Global, é necessário fornecer informações e detalhes adicionais nas seções que abrem caixas de resposta.</p>
                    <p>3. As informações fornecidas neste formulário serão confidenciais e não serão divulgadas sem a aprovação e consentimento da sua instituição.</p>

                    <br />

                    <Table striped bordered hover>

                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: '#e6f7ec' }} >
                                    <Link to='#' style={{ color: questao3 }} onClick={() => {setEnunciado('Sua instituição conduziu treinamentos sobre impactos da mudança do clima na saúde e soluções saudáveis para o problema*?');setSecaoEnunciado('Ações de Liderança');window.$('#modalValidacao').modal('show')}}>
                                    Sua instituição conduziu treinamentos sobre impactos da mudança do clima na saúde e soluções para o problema?
                                    </Link>
                                    
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Sim
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não
                                    </center>
                                </td>

                            </tr>


                            <tr>
                                <td>
                                    Para funcionários em geral
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="lideranca_funcionarios" onClick={() => setLideranca_funcionarios(true)} checked={lideranca_funcionarios ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="lideranca_funcionarios" onClick={() => setLideranca_funcionarios(false)} checked={lideranca_funcionarios != null && !lideranca_funcionarios ? 1 : 0} disabled />
                                    </center>
                                </td>

                            </tr>

                            <tr>
                                <td>
                                    Para profissionais de saúde
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="lideranca_medicos" onClick={() => setLideranca_medicos(true)} checked={lideranca_medicos ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="lideranca_medicos" onClick={() => setLideranca_medicos(false)} checked={!lideranca_medicos && lideranca_medicos != null ? 1 : 0} disabled />
                                    </center>
                                </td>

                            </tr>

                            <tr>
                                <td>
                                    Para pacientes
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="lideranca_pacientes" onClick={() => setLideranca_pacientes(true)} checked={lideranca_pacientes ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="lideranca_pacientes" onClick={() => setLideranca_pacientes(false)} checked={!lideranca_pacientes && lideranca_pacientes != null ? 1 : 0} disabled />
                                    </center>
                                </td>

                            </tr>
                            <tr>
                                <td>
                                    Para a comunidade
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="lideranca_comunidade" onClick={() => setLideranca_comunidade(true)} checked={lideranca_comunidade ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="lideranca_comunidade" onClick={() => setLideranca_comunidade(false)} checked={!lideranca_comunidade && lideranca_comunidade != null ? 1 : 0} disabled />
                                    </center>
                                </td>

                            </tr>
                            <tr>
                                <td>
                                    Para visitantes
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="lideranca_visitantes" onClick={() => setLideranca_visitantes(true)} checked={lideranca_visitantes ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="lideranca_visitantes" onClick={() => setLideranca_visitantes(false)} checked={!lideranca_visitantes && lideranca_visitantes != null ? 1 : 0} disabled />
                                    </center>
                                </td>

                            </tr>
                            <tr>
                                <td>
                                    Para mídia e jornalistas
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="lideranca_midia" onClick={() => setLideranca_midia(true)} checked={lideranca_midia ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="lideranca_midia" onClick={() => setLideranca_midia(false)} checked={!lideranca_midia && lideranca_midia != null ? 1 : 0} disabled />
                                    </center>
                                </td>


                            </tr>
                            <tr>
                                <td>
                                    Outro
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="lideranca_outro" onClick={() => setLideranca_outro(true)} checked={lideranca_outro ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="lideranca_outro" onClick={() => setLideranca_outro(false)} checked={!lideranca_outro && lideranca_outro != null ? 1 : 0} disabled />
                                    </center>
                                </td>
                            </tr>

                            <tr>
                                <td colspan="3">

                                    Por favor, descreva essas atividades:
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">
                                    <textarea className="form-control" rows="5" maxLength={1000} value={lideranca_atividades} onChange={event => setLideranca_atividades(event.target.value)} placeholder="Aqui..." disabled />
                                </td>
                            </tr>

                        </tbody>
                    </Table>


                    <Table striped bordered hover>

                        <tbody>
                            <tr>
                                <td rowspan="2" style={{ backgroundColor: '#e6f7ec' }} >
                                    <Link to='#' style={{ color: questao4 }} onClick={() => {setEnunciado('A sua instituição realizou capacitações em comunicação de riscos e gestão de crises (focada nos impactos das alterações climáticas na saúde) aos seus colaboradores, comunidade interna e à liderança?');setSecaoEnunciado('Ações de Liderança');window.$('#modalValidacao').modal('show')}}>
                                    A sua instituição realizou capacitações em comunicação de riscos e gestão de crises (focada nos impactos das alterações climáticas na saúde) aos seus colaboradores, comunidade interna e à liderança?
                                    </Link>
                                    
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Sim
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não
                                    </center>
                                </td>

                            </tr>


                            <tr>

                                <td>
                                    <center>
                                        <input type="radio" name="lideranca_capacitacao" onClick={() => setLideranca_capacitacao(true)} checked={lideranca_capacitacao ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="lideranca_capacitacao" onClick={() => setLideranca_capacitacao(false)} checked={lideranca_capacitacao != null && !lideranca_capacitacao ? 1 : 0} disabled />
                                    </center>
                                </td>
                            </tr>


                            <tr>
                                <td colspan="3">

                                    Por favor, descreva essas ações:
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">
                                    <textarea className="form-control" rows="5" maxLength={1000} value={lideranca_capacitacao_descricao} onChange={event => setLideranca_capacitacao_descricao(event.target.value)} placeholder="Aqui..." disabled />
                                </td>
                            </tr>

                            <br />

                            <tr>
                                <td style={{ backgroundColor: '#e6f7ec' }} >
                                    <Link to='#' style={{ color: questao5 }} onClick={() => {setEnunciado('A sua instituição participou em atividades educativas e de sensibilização entre tomadores de decisões para debater os impactos climáticos na saúde e trouxe soluções para o problema?');setSecaoEnunciado('Ações de Liderança');window.$('#modalValidacao').modal('show')}}>
                                    A sua instituição participou em atividades educativas e de sensibilização entre tomadores de decisões para debater os impactos climáticos na saúde e trouxe soluções para o problema?
                                    </Link>
                                    
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Sim
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não
                                    </center>
                                </td>

                            </tr>


                            <tr>
                                <td>
                                    Para tomadores de decisões a nível local
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="lideranca_educativa_local" onClick={() => setLideranca_educativa_local(true)} checked={lideranca_educativa_local ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="lideranca_educativa_local" onClick={() => setLideranca_educativa_local(false)} checked={!lideranca_educativa_local && lideranca_educativa_local != null ? 1 : 0} disabled />
                                    </center>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Para tomadores de decisões a nível estadual
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="lideranca_educativa_estadual" onClick={() => setLideranca_educativa_estadual(true)} checked={lideranca_educativa_estadual ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="lideranca_educativa_estadual" onClick={() => setLideranca_educativa_estadual(false)} checked={!lideranca_educativa_estadual && lideranca_educativa_estadual != null ? 1 : 0} disabled />
                                    </center>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Para tomadores de decisões a nível nacional
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="lideranca_educativa_nacional" onClick={() => setLideranca_educativa_nacional(true)} checked={lideranca_educativa_nacional ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="lideranca_educativa_nacional" onClick={() => setLideranca_educativa_nacional(false)} checked={!lideranca_educativa_nacional && lideranca_educativa_nacional != null ? 1 : 0} disabled />
                                    </center>
                                </td>
                            </tr>

                            <tr>
                                <td colspan="3">

                                    Por favor, descreva essas ações:
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">
                                    <textarea className="form-control" rows="5" maxLength={1000} value={lideranca_educativa_descricao} onChange={event => setLideranca_educativa_descricao(event.target.value)} placeholder="Aqui..." disabled />
                                </td>
                            </tr>


                        </tbody>
                    </Table>



                </div>



                <div className="col-md-12">


                    <br /><br />

                    <b>LIDERANÇA POLÍTICA</b>

                    <br /><br />



                    <Table striped bordered hover>

                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: '#e6f7ec' }} >

                                <Link to='#' style={{ color: questao6 }} onClick={() => {setEnunciado('Sua instituição atuou em defesa de políticas para o enfrentamento da mudança do clima nas seguintes questões*?');setSecaoEnunciado('Ações de Liderança');window.$('#modalValidacao').modal('show')}}>
                                Sua instituição atuou em defesa de políticas para o enfrentamento da mudança do clima nas seguintes questões?
                                </Link>
                                    

                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Sim
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Selecione o nível
                                    </center>
                                </td>


                            </tr>

                            <tr>
                                <td>
                                    Redução de emissões de GEE no setor saúde
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="politica_clima_gee" onClick={() => setPolitica_clima_gee(true)} checked={politica_clima_gee ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="politica_clima_gee" onClick={() => setPolitica_clima_gee(false)} checked={!politica_clima_gee && politica_clima_gee != null ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <select className='form-control' name="politica_clima_gee_nivel" value={politica_clima_gee_nivel} onChange={(e) => setPolitica_clima_gee_nivel(e.target.value)} disabled>
                                            <option value="">[Selecione]</option>
                                            <option value="L">Local</option>
                                            <option value="E">Estadual</option>
                                            <option value="N">Nacional</option>
                                            <option value="I">Internacional</option>
                                        </select>
                                    </center>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Adaptação do setor saúde à mudança do clima
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="politica_clima_adaptacao" onClick={() => setPolitica_clima_adaptacao(true)} checked={politica_clima_adaptacao ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="politica_clima_adaptacao" onClick={() => setPolitica_clima_adaptacao(false)} checked={!politica_clima_adaptacao && politica_clima_adaptacao != null ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <select className='form-control' name="politica_clima_adaptacao_nivel" value={politica_clima_adaptacao_nivel} onChange={(e) => setPolitica_clima_adaptacao_nivel(e.target.value)} disabled>
                                            <option value="">[Selecione]</option>
                                            <option value="L">Local</option>
                                            <option value="E">Estadual</option>
                                            <option value="N">Nacional</option>
                                            <option value="I">Internacional</option>
                                        </select>
                                    </center>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Transição de combustíveis fósseis para fontes de energia limpa e renovável
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="politica_clima_transicao" onClick={() => setPolitica_clima_transicao(true)} checked={politica_clima_transicao ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="politica_clima_transicao" onClick={() => setPolitica_clima_transicao(false)} checked={!politica_clima_transicao && politica_clima_transicao != null ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <select className='form-control' name="politica_clima_transicao_nivel" value={politica_clima_transicao_nivel} onChange={(e) => setPolitica_clima_transicao_nivel(e.target.value)} disabled>
                                            <option value="">[Selecione]</option>
                                            <option value="L">Local</option>
                                            <option value="E">Estadual</option>
                                            <option value="N">Nacional</option>
                                            <option value="I">Internacional</option>
                                        </select>
                                    </center>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Acesso das organizações de saúde a recursos para adaptação/mitigação
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="politica_clima_mitigacao" onClick={() => setPolitica_clima_mitigacao(true)} checked={politica_clima_mitigacao ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="politica_clima_mitigacao" onClick={() => setPolitica_clima_mitigacao(false)} checked={!politica_clima_mitigacao && politica_clima_mitigacao != null ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <select className='form-control' name="politica_clima_mitigacao_nivel" value={politica_clima_mitigacao_nivel} onChange={(e) => setPolitica_clima_mitigacao_nivel(e.target.value)} disabled>
                                            <option value="">[Selecione]</option>
                                            <option value="L">Local</option>
                                            <option value="E">Estadual</option>
                                            <option value="N">Nacional</option>
                                            <option value="I">Internacional</option>
                                        </select>
                                    </center>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4">

                                    Por favor, descreva essas atividades:
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4">
                                    <textarea className="form-control" rows="5" maxLength={1000} placeholder="Aqui..." value={politica_clima_descricao} onChange={event => setPolitica_clima_descricao(event.target.value)} disabled />
                                </td>
                            </tr>



                        </tbody>
                    </Table>



                </div>


                <div className="col-md-12">


                    <br /><br />

                    <b>ESTRUTURA ORGANIZACIONAL, GOVERNANÇA E PRÁTICA</b>

                    <br /><br />



                    <Table striped bordered hover>

                        <tbody>
                            <tr>
                                <td rowspan="2" style={{ backgroundColor: '#e6f7ec' }} >
                                <Link to='#' style={{ color: questao7 }} onClick={() => {setEnunciado('A sua instituição tem funcionários, equipe ou comitê dedicado(s) ao trabalho sobre clima e saúde*?');setSecaoEnunciado('Ações de Liderança');window.$('#modalValidacao').modal('show')}}>
                                    A sua instituição tem funcionários, equipe ou comitê dedicado(s) ao trabalho sobre clima e saúde?
                                </Link>
                                    

                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Sim
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não
                                    </center>
                                </td>
                            </tr>
                            <tr>

                                <td>
                                    <center>
                                        <input type="radio" name="governanca_funcionarios" onClick={() => setGovernanca_funcionarios(true)} checked={governanca_funcionarios ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="governanca_funcionarios" onClick={() => setGovernanca_funcionarios(false)} checked={!governanca_funcionarios && governanca_funcionarios != null ? 1 : 0} disabled />
                                    </center>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">

                                    Por favor, descreva o grupo de trabalho e quantas pessoas participam:
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">
                                    <textarea className="form-control" rows="5" maxLength={1000} placeholder="Aqui..." value={governanca_funcionarios_descricao} onChange={event => setGovernanca_funcionarios_descricao(event.target.value)} disabled />
                                </td>
                            </tr>

                            <br />

                            <tr>
                                <td rowspan="2" style={{ backgroundColor: '#e6f7ec' }}>
                                
                                    <Link to='#' style={{ color: questao8 }} onClick={() => {setEnunciado('A sua instituição tem políticas para edifícios verdes e reformas que seguem normas ou melhores práticas nacionais ou internacionais. *?');setSecaoEnunciado('Ações de Liderança');window.$('#modalValidacao').modal('show')}}>
                                    A sua instituição tem políticas para edifícios verdes e reformas que seguem normas ou melhores práticas nacionais ou internacionais?
                                    </Link>
                                    
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Sim
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não
                                    </center>
                                </td>
                            </tr>
                            <tr>

                                <td>
                                    <center>
                                        <input type="radio" name="governanca_verdes" onClick={() => setGovernanca_verdes(true)} checked={governanca_verdes ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="governanca_verdes" onClick={() => setGovernanca_verdes(false)} checked={!governanca_verdes && governanca_verdes != null ? 1 : 0} disabled />
                                    </center>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">

                                    Por favor, descreva quais normas e melhores práticas são utilizadas:
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">
                                    <textarea className="form-control" rows="5" maxLength={1000} placeholder="Aqui..." value={governanca_verdes_descricao} onChange={event => setGovernanca_verdes_descricao(event.target.value)} disabled />
                                </td>
                            </tr>

                            <br />

                            <tr>
                                <td rowspan="2" style={{ backgroundColor: '#e6f7ec' }}>
                                
                                    <Link to='#' style={{ color: questao9 }} onClick={() => {setEnunciado('A sua instituição tem políticas que a comprometem a tomar medidas em matéria de mitigação e resiliência *?');setSecaoEnunciado('Ações de Liderança');window.$('#modalValidacao').modal('show')}}>
                                    A sua instituição tem políticas que a comprometem a tomar medidas em matéria de mitigação e resiliência?
                                    </Link>
                                    
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Sim
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não
                                    </center>
                                </td>
                            </tr>
                            <tr>

                                <td>
                                    <center>
                                        <input type="radio" name="governanca_mitigacao" onClick={() => setGovernanca_mitigacao(true)} checked={governanca_mitigacao ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="governanca_mitigacao" onClick={() => setGovernanca_mitigacao(false)} checked={!governanca_mitigacao && governanca_mitigacao != null ? 1 : 0} disabled />
                                    </center>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">

                                    Por favor, descreva essas políticas:
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">
                                    <textarea className="form-control" rows="5" maxLength={1000} placeholder="Aqui..." value={governanca_mitigacao_descricao} onChange={event => setGovernanca_mitigacao_descricao(event.target.value)} disabled />
                                </td>
                            </tr>

                            <br />

                            <tr>
                                <td rowspan="2" style={{ backgroundColor: '#e6f7ec' }}>
                                    <Link to='#' style={{ color: questao10 }} onClick={() => {setEnunciado('A sua instituição oferece incentivos ou oportunidades para apoiar os funcionários na redução da sua pegada de carbono?');setSecaoEnunciado('Ações de Liderança');window.$('#modalValidacao').modal('show')}}>
                                    A sua instituição oferece incentivos ou oportunidades para apoiar os funcionários na redução da sua pegada de carbono? (por exemplo, incentivos para usar bicicleta, incentivo para utilização de carona solidária e etc.)
                                    </Link>
                                    
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Sim
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não
                                    </center>
                                </td>
                            </tr>
                            <tr>

                                <td>
                                    <center>
                                        <input type="radio" name="governanca_incentivos" onClick={() => setGovernanca_incentivos(true)} checked={governanca_incentivos ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="governanca_incentivos" onClick={() => setGovernanca_incentivos(false)} checked={!governanca_incentivos && governanca_incentivos != null ? 1 : 0} disabled />
                                    </center>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">

                                    Por favor, descreva as ações de incentivo:
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">
                                    <textarea className="form-control" rows="5" maxLength={1000} placeholder="Aqui..." value={governanca_incentivos_descricao} onChange={event => setGovernanca_incentivos_descricao(event.target.value)} disabled />
                                </td>
                            </tr>

                            <br />

                            <tr>
                                <td rowspan="2" style={{ backgroundColor: '#e6f7ec' }}>

                                    <Link to='#' style={{ color: questao11 }} onClick={() => {setEnunciado('A sua instituição oferece benefícios comunitários que reduzem as emissões de carbono ou aumentam a resiliência da comunidade (hortas comunitárias ou espaços verdes, energia solar comunitária, programas de ar e água limpos, plantação de árvores e etc.) *?');setSecaoEnunciado('Ações de Liderança');window.$('#modalValidacao').modal('show')}}>
                                    A sua instituição oferece benefícios comunitários que reduzem as emissões de carbono ou aumentam a resiliência da comunidade (hortas comunitárias ou espaços verdes, energia solar comunitária, programas de ar e água limpos, plantação de árvores e etc.)?
                                    </Link>
                                    
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Sim
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não
                                    </center>
                                </td>
                            </tr>
                            <tr>

                                <td>
                                    <center>
                                        <input type="radio" name="governanca_beneficios" onClick={() => setGovernanca_beneficios(true)} checked={governanca_beneficios ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="governanca_beneficios" onClick={() => setGovernanca_beneficios(false)} checked={!governanca_beneficios && governanca_beneficios != null ? 1 : 0} disabled />
                                    </center>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">

                                    Por favor, descreva os benefícios comunitários:
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">
                                    <textarea className="form-control" rows="5" maxLength={1000} placeholder="Aqui..." value={governanca_beneficios_descricao} onChange={event => setGovernanca_beneficios_descricao(event.target.value)} disabled />
                                </td>
                            </tr>


                        </tbody>
                    </Table>



                </div>


                <div className="col-md-12">


                    <br /><br />

                    <b>LIDERANÇA ECONÔMICA</b>

                    <br /><br />



                    <Table striped bordered hover>

                        <tbody>

                            <tr>
                                <td rowspan="2" style={{ backgroundColor: '#e6f7ec' }} colspan="2">
                                <Link to='#' style={{ color: questao12 }} onClick={() => {setEnunciado('Sua instituição avalia o plano estratégico de negócio visando encontrar benefícios económicos viáveis para a implementação de políticas, projetos e iniciativas para reduzir a sua pegada de carbono *?');setSecaoEnunciado('Ações de Liderança');window.$('#modalValidacao').modal('show')}}>
                                    Sua instituição avalia o plano estratégico visando encontrar benefícios econômicos viáveis para a implementação de políticas, projetos e iniciativas para reduzir a sua pegada de carbono?
                                </Link>
                                    
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }} colspan="1">
                                    <center>
                                        Sim
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }} colspan="1">
                                    <center>
                                        Não
                                    </center>
                                </td>
                            </tr>
                            <tr>

                                <td colspan="1">
                                    <center>
                                        <input type="radio" name="economica_plano_carbono" onClick={() => setEconomica_plano_carbono(true)} checked={economica_plano_carbono ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td colspan="1">
                                    <center>
                                        <input type="radio" name="economica_plano_carbono" onClick={() => setEconomica_plano_carbono(false)} checked={!economica_plano_carbono && economica_plano_carbono != null ? 1 : 0} disabled />
                                    </center>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4">

                                    Por favor, descreva os benefícios comunitários:
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4">
                                    <textarea className="form-control" rows="5" maxLength={1000} placeholder="Aqui..." value={economica_plano_carbono_descricao} onChange={event => setEconomica_plano_carbono_descricao(event.target.value)} disabled />
                                </td>
                            </tr>

                            <br />

                            <tr>
                                <td rowSpan={2} style={{ backgroundColor: '#e6f7ec' }} >
                                <Link to='#' style={{ color: questao13 }} onClick={() => {setEnunciado('Investiu em projetos de energia limpa, saudável ou renovável *?');setSecaoEnunciado('Ações de Liderança');window.$('#modalValidacao').modal('show')}}>
                                Investiu em projetos de energia limpa ou renovável?
                                </Link>
                                    

                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Sim
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não se aplica
                                    </center>
                                </td>

                            </tr>
                            <tr>

                                <td>
                                    <center>
                                        <input type="radio" name="economica_energiaLimpa" onClick={() => setEconomica_energiaLimpa('S')} checked={economica_energiaLimpa == 'S' ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="economica_energiaLimpa" onClick={() => setEconomica_energiaLimpa('N')} checked={economica_energiaLimpa == 'N' ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="economica_energiaLimpa" onClick={() => setEconomica_energiaLimpa('A')} checked={economica_energiaLimpa == 'A' ? 1 : 0} disabled />
                                    </center>
                                </td>

                            </tr>
                            <tr>
                                <td colspan="4">

                                    Por favor, descreva os projetos:
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4">
                                    <textarea className="form-control" rows="5" maxLength={1000} placeholder="Aqui..." value={economica_energiaLimpa_descricao} onChange={event => setEconomica_energiaLimpa_descricao(event.target.value)} disabled />
                                </td>
                            </tr>

                            <br />

                            <tr>
                                <td rowspan="2" style={{ backgroundColor: '#e6f7ec' }} >
                                <Link to='#' style={{ color: questao14 }} onClick={() => {setEnunciado('Investiu em projetos ou empresas energeticamente eficientes *?');setSecaoEnunciado('Ações de Liderança');window.$('#modalValidacao').modal('show')}}>
                                    Investiu em projetos ou empresas energeticamente eficientes?
                                </Link>
                                    
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Sim
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não se aplica
                                    </center>
                                </td>
                            </tr>
                            <tr>

                                <td>
                                    <center>
                                        <input type="radio" name="economica_eficientes" onClick={() => setEconomica_eficientes('S')} checked={economica_eficientes == 'S' ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="economica_eficientes" onClick={() => setEconomica_eficientes('N')} checked={economica_eficientes == 'N' ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="economica_eficientes" onClick={() => setEconomica_eficientes('A')} checked={economica_eficientes == 'A' ? 1 : 0} disabled />
                                    </center>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4">

                                    Por favor, descreva os projetos:
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4">
                                    <textarea className="form-control" rows="5" maxLength={1000} placeholder="Aqui..." value={economica_eficientes_descricao} onChange={event => setEconomica_eficientes_descricao(event.target.value)} disabled />
                                </td>
                            </tr>

                            <br />

                            <tr>
                                <td rowspan="2" style={{ backgroundColor: '#e6f7ec' }}>
                                    <Link to='#' style={{ color: questao15 }} onClick={() => {setEnunciado('Criou um programa/acordo interno que reinveste a parte dos recursos financeiros economizados em futuros projetos de energia e sustentabilidade *?');setSecaoEnunciado('Ações de Liderança');window.$('#modalValidacao').modal('show')}}>
                                    Criou um programa/acordo interno que reinveste a parte dos recursos financeiros economizados em futuros projetos de energia e sustentabilidade?
                                    </Link>
                                    
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Sim
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não se aplica
                                    </center>
                                </td>
                            </tr>
                            <tr>

                                <td>
                                    <center>
                                        <input type="radio" name="economica_acordo" onClick={() => setEconomica_acordo('S')} checked={economica_acordo == 'S' ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="economica_acordo" onClick={() => setEconomica_acordo('N')} checked={economica_acordo == 'N' ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="economica_acordo" onClick={() => setEconomica_acordo('A')} checked={economica_acordo == 'A' ? 1 : 0} disabled />
                                    </center>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4">

                                    Por favor, descreva o programa/acordo:
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4">
                                    <textarea className="form-control" rows="5" maxLength={1000} placeholder="Aqui..." value={economica_acordo_descricao} onChange={event => setEconomica_acordo_descricao(event.target.value)} disabled />
                                </td>
                            </tr>

                            <br />

                            <tr>
                                <td rowspan="2" style={{ backgroundColor: '#e6f7ec' }} >

                                <Link to='#' style={{ color: questao16 }} onClick={() => {setEnunciado('Sua instituição congelou investimentos em outros combustíveis fósseis?');setSecaoEnunciado('Ações de Liderança');window.$('#modalValidacao').modal('show')}}>
                                    Sua instituição congelou investimentos em combustíveis fósseis?
                                </Link>

                                    

                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Sim
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não se aplica
                                    </center>
                                </td>

                            </tr>
                            <tr>

                                <td>
                                    <center>
                                        <input type="radio" name="economica_fosseis" onClick={() => setEconomica_fosseis('S')} checked={economica_fosseis == 'S' ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="economica_fosseis" onClick={() => setEconomica_fosseis('N')} checked={economica_fosseis == 'N' ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="economica_fosseis" onClick={() => setEconomica_fosseis('A')} checked={economica_fosseis == 'A' ? 1 : 0} disabled />
                                    </center>
                                </td>

                            </tr>
                            <tr>
                                <td colspan="4">

                                    Por favor, descreva:
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4">
                                    <textarea className="form-control" maxLength={1000} rows="5" placeholder="Aqui..." value={economica_fosseis_descricao} onChange={event => setEconomica_fosseis_descricao(event.target.value)} disabled />
                                </td>
                            </tr>

                            <br />

                            <tr style={{ display: 'none'}}>
                                <td rowspan="2" style={{ backgroundColor: '#e6f7ec' }} >

                                <Link to='#' style={{ color: questao17 }} onClick={() => {setEnunciado('Sua instituição congelou investimentos em carvão?');setSecaoEnunciado('Ações de Liderança');window.$('#modalValidacao').modal('show')}}>
                                    Sua instituição congelou investimentos em carvão?
                                </Link>
                                    

                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Sim
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não se aplica
                                    </center>
                                </td>

                            </tr>
                            <tr style={{ display: 'none'}}>

                                <td>
                                    <center>
                                        <input type="radio" name="economica_carvao" onClick={() => setEconomica_carvao('S')} checked={economica_carvao == 'S' ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="economica_carvao" onClick={() => setEconomica_carvao('N')} checked={economica_carvao == 'N' ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="economica_carvao" onClick={() => setEconomica_carvao('A')} checked={economica_carvao == 'A' ? 1 : 0} disabled />
                                    </center>
                                </td>

                            </tr>
                            <tr style={{ display: 'none'}}>
                                <td colspan="4">

                                    Por favor, descreva:
                                </td>
                            </tr>
                            <tr style={{ display: 'none'}}>
                                <td colspan="4">
                                    <textarea className="form-control" rows="5" maxLength={1000} placeholder="Aqui..." value={economica_carvao_descricao} onChange={event => setEconomica_carvao_descricao(event.target.value)} disabled />
                                </td>
                            </tr>

                            <br />

                            <tr>
                                <td rowspan="2" style={{ backgroundColor: '#e6f7ec' }}>
                                <Link to='#' style={{ color: questao18 }} onClick={() => {setEnunciado('Adotou critérios para compra de produtos com base na sua sustentabilidade e pegada de carbono *?');setSecaoEnunciado('Ações de Liderança');window.$('#modalValidacao').modal('show')}}>
                                    Adotou critérios para compra de produtos com base na sua sustentabilidade e/ou pegada de carbono?
                                </Link>
                                    
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Sim
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não se aplica
                                    </center>
                                </td>
                            </tr>
                            <tr>

                                <td>
                                    <center>
                                        <input type="radio" name="economica_compra_carbono" onClick={() => setEconomica_compra_carbono('S')} checked={economica_compra_carbono == 'S' ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="economica_compra_carbono" onClick={() => setEconomica_compra_carbono('N')} checked={economica_compra_carbono == 'N' ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="economica_compra_carbono" onClick={() => setEconomica_compra_carbono('A')} checked={economica_compra_carbono == 'A' ? 1 : 0} disabled />
                                    </center>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4">

                                    Por favor, descreva os critérios:

                                </td>
                            </tr>
                            <tr>
                                <td colspan="4">
                                    <textarea className="form-control" rows="5" maxLength={1000} placeholder="Aqui..." value={economica_compra_carbono_descricao} onChange={event => setEconomica_compra_carbono_descricao(event.target.value)} disabled />
                                </td>
                            </tr>

                        </tbody>
                    </Table>



                </div>


                <div className="col-md-12">

                    <br />
                    <Link to='#' style={{ color: questao19 }} onClick={() => {setEnunciado('Utilize o campo abaixo para fornecer informações adicionais sobre as iniciativas de liderança climática como, por exemplo:');setSecaoEnunciado('Ações de Liderança');window.$('#modalValidacao').modal('show')}}>
                    <b>Utilize o campo abaixo para fornecer informações adicionais sobre as iniciativas de liderança climática como, por exemplo:</b>
                    </Link>
                    

                    <br /><br />
                    <ul>
                        <li>* Alocação de profissionais para desenvolvimento de iniciativas na área de clima</li>
                        <li>* Treinamento específico para ações na área de clima</li>
                        <li>* Inserção da questão climática no planejamento estratégico da instituição</li>
                        <li>* Ações de sensibilização para público externo</li>
                        <li>* Ações junto aos fornecedores da cadeia de fornecimento para redução das emissões de carbono</li>
                    </ul>


                    <textarea className="form-control" rows="5" maxLength={1000} placeholder="Descreva aqui..." value={iniciativasLideranca} onChange={event => setIniciativasLideranca(event.target.value)} disabled />


                </div>


            </div>



            <StatusValidacaoSecao desafio="Clima" secaoCampo="secaoAcoesLideranca" totalPendencias={totalPendencias} nomeDesafio="Desafio Clima" formulario_id={formulario_id} secao="Ações de Liderança" adesao_institucional_id={adesao_institucional_id} ano={ano} />





        </div>
    )

}

export default AcoesLideranca